/* Generating (VSL) state -> ready/pricing state. Sales logic re-implemented from the captured section script. */
(function(){
var SID='template--33747178586502__bliss_preview_sales_SALES1';
var $=function(id){return document.getElementById(id+'-'+SID)};
var root=document.getElementById('bps-'+SID);
var S={};try{S=JSON.parse(localStorage.getItem('quiz')||'{}')}catch(e){}
var name=S.name||'',rec=(S.recipient||'').toLowerCase();
var pron={husband:'his',father:'his',wife:'her',mother:'her',myself:'your'}[rec]||(rec==='friend'||rec==='sibling'||rec==='children'||rec==='other'?'their':'her');
var relText={husband:'husband',wife:'wife',children:'child or grandchild',father:'father',mother:'mother',sibling:'brother or sister',friend:'dear friend',myself:'',other:'loved one'}[rec];if(relText===undefined)relText=rec;
fill('[data-preview-name]',name||'Your Loved One');fill('[data-preview-genre]',S.genre||'Your');fill('[data-preview-relationship]',relText);
/* hide ", written for your …" when the song is for the buyer or the relationship is unknown */
[].forEach.call(root.querySelectorAll('[data-preview-rel-wrap]'),function(e){e.hidden=!relText||rec==='myself'});
function fill(sel,v){[].forEach.call(root.querySelectorAll(sel),function(e){e.textContent=v})}
var d=root.querySelector('.bps-bump-desc');d.textContent=d.textContent.replace('with her name','with '+pron+' name');

/* ---- single VSL (no split test: vsl_a, the one without the presenter, served from the song worker) ---- */
var VARIANTS={a:{video:'https://cira-song-api.ciracove.workers.dev/vsl/a.mp4',total:711}},variant='a',qp=new URLSearchParams(location.search);

/* ---- wait / pricing reveal (logic from the original dario_preview_wait + bliss_preview_sales scripts) ---- */
var v=document.getElementById('v');
v.poster='https://cira-song-api.ciracove.workers.dev/vsl/poster.jpg';v.src=VARIANTS[variant].video;v.muted=true;
var vp=v.play();if(vp&&vp.catch)vp.catch(function(){});
var TOTAL_SECONDS=qp.get('fast')==='1'?12:VARIANTS[variant].total;
var STAGES=[{label:'Writing the lyrics…',end:15},{label:'Composing the melody…',end:35},{label:'Producing the music…',end:55},{label:'Recording the vocals…',end:75},{label:'Final mix — weaving in the name…',end:95}];
var maxStageEnd=STAGES[STAGES.length-1].end;
/* progress colours follow the theme: wine → gold as the song comes together */
var PHASES=[{min:0,max:25,grad:'linear-gradient(90deg,var(--theme-wine-dark),var(--theme-wine))',glow:'rgba(var(--theme-wine-rgb),0.35)'},{min:25,max:50,grad:'linear-gradient(90deg,var(--theme-wine),var(--theme-wine-light))',glow:'rgba(var(--theme-wine-rgb),0.35)'},{min:50,max:75,grad:'linear-gradient(90deg,var(--theme-wine-light),var(--theme-gold))',glow:'rgba(var(--theme-gold-rgb),0.4)'},{min:75,max:100,grad:'linear-gradient(90deg,var(--theme-gold),var(--theme-gold-light))',glow:'rgba(var(--theme-gold-rgb),0.5)'}];
var fillEl=document.getElementById('pb'),pctEl=document.getElementById('pc'),lbl=document.getElementById('st'),tm=document.getElementById('tm'),vb=document.getElementById('vb');
var captionEl=document.querySelector('.dpw-caption');
var startTime=Date.now(),highWater=0,timer=null,timerDone=false,resolved=false,salesShown=false;
function f(s){s=Math.max(0,Math.floor(s));return('0'+Math.floor(s/60)).slice(-2)+':'+('0'+s%60).slice(-2)}
function applyPhase(pct){for(var p=PHASES.length-1;p>=0;p--){if(pct>=PHASES[p].min){fillEl.style.background=PHASES[p].grad;fillEl.style.boxShadow='0 0 8px '+PHASES[p].glow;break}}}
function setDone(){fillEl.style.width='100%';applyPhase(100);pctEl.textContent='100%';lbl.textContent='Your preview is ready'}
function revealPreviewSections(){
  document.querySelectorAll('[data-preview-section]').forEach(function(el){el.classList.add('preview-visible')});
  window.__previewReady=true;
  document.dispatchEvent(new CustomEvent('preview:sections-reveal'));
}
function revealCtaInstant(){
  resolved=true;if(timer)clearInterval(timer);
  fillEl.style.transition='none';fillEl.style.width='0%';fillEl.offsetWidth;
  fillEl.style.transition='width 1s linear, background 0.9s ease, box-shadow 0.9s ease';
  setDone();revealPreviewSections();
}
window.showHiddenDisplay=function(){resolved=true;if(timer)clearInterval(timer);setDone();revealPreviewSections()};
function revealSelf(){
  if(salesShown)return;salesShown=true;
  root.classList.add('preview-visible');
  var u=new URL(location.href);
  if(!u.searchParams.has('skipPreview')){u.searchParams.set('skipPreview','1');history.replaceState(null,'',u.toString())}
  document.dispatchEvent(new CustomEvent('preview:sales-visible'));
  document.body.classList.remove('waiting');
  document.getElementById('wait').style.minHeight='auto';
  if(captionEl)captionEl.style.display='none';
  startCountdown();
}
document.addEventListener('preview:sections-reveal',revealSelf);
document.addEventListener('preview:sales-visible',function(){
  resolved=true;if(timer)clearInterval(timer);
  var ps=fillEl.closest('.dpw-progress-section');if(ps)ps.style.display='none';
});
var offerAnchor=$('bps-offerAnchor');
window.showPreviewSales=revealSelf;
var skipPreview=qp.get('skipPreview')==='1';
if(skipPreview||location.hash==='#ready'){
  revealCtaInstant();
  if(skipPreview)setTimeout(function(){if(offerAnchor)offerAnchor.scrollIntoView({behavior:'instant',block:'start'})},100);
}
setTimeout(function(){if(!resolved)revealCtaInstant()},TOTAL_SECONDS*1000);
document.addEventListener('visibilitychange',function(){
  if(resolved||document.hidden)return;
  if(Math.round((Date.now()-startTime)/1000)>=TOTAL_SECONDS)revealCtaInstant();
});
function dpwEase(t){
  if(t<=0.25)return(t/0.25)*0.50;
  if(t<=0.4167)return 0.50+((t-0.25)/0.1667)*0.25;
  return 0.75+((t-0.4167)/0.5833)*0.25;
}
timer=setInterval(function(){
  if(resolved){clearInterval(timer);return}
  var elapsed=Math.round((Date.now()-startTime)/1000);
  var linear=Math.min(elapsed/Math.max(TOTAL_SECONDS-5,1),1);
  var progress=Math.min(Math.round(dpwEase(linear)*maxStageEnd),maxStageEnd);
  progress=Math.max(progress,highWater);highWater=progress;
  fillEl.style.width=progress+'%';pctEl.textContent=progress+'%';applyPhase(progress);
  tm.textContent=f(TOTAL_SECONDS-elapsed);vb.style.width=Math.min(100,elapsed/TOTAL_SECONDS*100)+'%';
  for(var j=STAGES.length-1;j>=0;j--){var prevEnd=j>0?STAGES[j-1].end:0;if(progress>=prevEnd){lbl.textContent=STAGES[j].label;break}}
  if(progress>=maxStageEnd){clearInterval(timer);timerDone=true;setDone();revealPreviewSections()}
},1000);
tm.textContent=f(TOTAL_SECONDS);

/* ---- waveform + audio ---- */
var wf=$('bps-waveform'),N=52,bars;
for(var i=0;i<N;i++){var pos=i/N,base=.3+.7*(.5+.3*Math.sin(pos*12)+.2*Math.sin(pos*28+1.3)+.15*Math.sin(pos*47)),bar=document.createElement('div');bar.className='bps-bar';bar.style.height=(Math.max(.15,Math.min(1,base))*100)+'%';wf.appendChild(bar)}
bars=wf.querySelectorAll('.bps-bar');
var au=$('bps-audio'),pbtn=$('bps-playBtn'),plab=$('bps-playLabel'),tcur=$('bps-timeCurrent'),dur=$('bps-durationLabel'),cta=$('bps-primaryCta'),raf=null,ended=false;
function ft(s){return Math.floor(s/60)+':'+('0'+Math.floor(s%60)).slice(-2)}
/* bars track the 90-second preview window (stream URLs report an infinite duration) */
function upd(){var D=isFinite(au.duration)&&au.duration>0?Math.min(au.duration,90):90;
 var n=Math.min(bars.length,Math.floor(au.currentTime/D*bars.length));for(var j=0;j<bars.length;j++)bars[j].classList.toggle('active',j<n);
 tcur.textContent=ft(au.currentTime);if(!au.paused)raf=requestAnimationFrame(upd)}
au.addEventListener('play',function(){if(raf)cancelAnimationFrame(raf);raf=requestAnimationFrame(upd)});
au.addEventListener('pause',function(){if(raf){cancelAnimationFrame(raf);raf=null}if(!au.ended&&!pbtn.classList.contains('ended')){pbtn.classList.remove('playing');plab.textContent='Tap to keep listening'}});
au.addEventListener('loadedmetadata',function(){dur.textContent=(au.duration>=90?'90s':Math.round(au.duration)+'s')+' preview'});
au.addEventListener('timeupdate',function(){if(au.currentTime>=90&&!au.paused){au.pause();au.dispatchEvent(new Event('ended'))}});
au.addEventListener('ended',function(){pbtn.classList.remove('playing');pbtn.classList.add('ended');plab.textContent='Hear the full song — see below ↓';plab.classList.add('complete');
 for(var j=0;j<bars.length;j++)bars[j].classList.add('active');
 if(!ended){ended=true;cta.classList.add('pulse');var n=$('bps-previewNudge');if(n){n.classList.add('visible');n.setAttribute('aria-hidden','false')}}});
pbtn.addEventListener('click',function(){if(au.paused){au.play().then(function(){pbtn.classList.remove('ended');pbtn.classList.add('playing');plab.textContent='Playing your preview…';plab.classList.remove('complete')}).catch(function(){})}
 else{au.pause();pbtn.classList.remove('playing');plab.textContent='Tap to keep listening'}});

/* ---- real song from the song API (window.CIRA_SONG_API, set in the layout; empty = off) ----
   POST /api/song if the quiz page did not get a taskId, then poll GET /api/song/:taskId every 4 s for up to 5 min.
   The first playable track replaces the sample (streamAudioUrl early, audioUrl once ready). Any failure: the sample stays. */
var API=(window.CIRA_SONG_API||'').replace(/\/+$/,''),songDeadline=Date.now()+300000,songSrc='',songFull=false,pendingSong=null,songTries=0,pollErrs=0;
function saveQuiz(){try{localStorage.setItem('quiz',JSON.stringify(S))}catch(e){}}
function applySong(p){
  pendingSong=null;songSrc=p.url;songFull=p.full;
  au.src=p.url;au.load();ended=false;
  pbtn.classList.remove('playing','ended');plab.classList.remove('complete');plab.textContent='Tap to play your preview';tcur.textContent='0:00';
  for(var j=0;j<bars.length;j++)bars[j].classList.remove('active');
  root.setAttribute('data-song-state',p.full?'full':'stream');
  if(p.track.imageUrl&&'mediaSession' in navigator&&window.MediaMetadata){try{navigator.mediaSession.metadata=new MediaMetadata({title:p.track.title||'A Song for '+(S.name||'You'),artist:'CIRA Cove',artwork:[{src:p.track.imageUrl}]})}catch(e){}}
}
/* never cut off something that is playing: swap once it is paused/ended (a stream -> full upgrade only before it was started) */
function offerSong(t){
  var url=t.audioUrl||t.streamAudioUrl,full=!!t.audioUrl;
  if(!url||url===songSrc||(songSrc&&songFull))return;
  var p={url:url,full:full,track:t},started=au.currentTime>0&&!au.ended;
  if(songSrc&&started)return;
  if(!au.paused){pendingSong=p;return}
  applySong(p);
}
au.addEventListener('pause',function(){if(pendingSong&&(!songSrc||au.ended||!au.currentTime))applySong(pendingSong)});
au.addEventListener('ended',function(){if(pendingSong)applySong(pendingSong)});
function pollSong(){
  if(!S.songTaskId||Date.now()>songDeadline)return;
  fetch(API+'/api/song/'+encodeURIComponent(S.songTaskId)).then(function(r){if(!r.ok)throw r.status;return r.json()}).then(function(j){
    pollErrs=0;
    if(j.failed){delete S.songTaskId;saveQuiz();if(songTries<2)setTimeout(startSong,1000);return}
    var ts=j.tracks||[],t=ts.filter(function(x){return x.audioUrl})[0]||ts.filter(function(x){return x.streamAudioUrl})[0];
    if(t){offerSong(t);if(t.id&&S.songTrackId!==t.id){S.songTrackId=t.id;saveQuiz()}if(t.audioUrl&&S.songAudioUrl!==t.audioUrl){S.songAudioUrl=t.audioUrl;saveQuiz()}}
    if(!(j.ready&&t&&t.audioUrl))setTimeout(pollSong,4000);
  }).catch(function(e){if(e!==404&&++pollErrs<6)setTimeout(pollSong,4000)});
}
function startSong(){
  if(Date.now()>songDeadline||songTries++>6)return;
  var a={};['name','recipient','occasion','genre','voice','language','qualities','moments','message'].forEach(function(k){if(S[k])a[k]=S[k]});
  fetch(API+'/api/song',{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify({quizId:S.quizId,answers:a})})
    .then(function(r){return r.json()}).then(function(j){
      if(j&&j.taskId){S.songTaskId=j.taskId;saveQuiz();pollSong()}
      else if(j&&j.pending)setTimeout(startSong,3000);   /* the quiz page's request is still running */
    }).catch(function(){});
}
root.setAttribute('data-song-state','sample');
/* generate only after GEN_AFTER s of VSL actually played (not page time); leaving earlier spends no credits.
   if the offer is revealed without that (e.g. video paused), generate at reveal. server still dedupes per quizId + rate limits. */
var GEN_AFTER=qp.get('fast')==='1'?5:60,played=0,lastT=null,genStarted=false;
function kickSong(){if(genStarted)return;genStarted=true;if(S.songTaskId)pollSong();else startSong()}
window.__songPlayed=function(){return played};
if(API&&window.fetch&&S.quizId&&S.name){
  if(S.songTaskId)kickSong();
  else{
    v.addEventListener('timeupdate',function(){var t=v.currentTime;if(lastT!==null&&!v.paused&&t>lastT&&t-lastT<2)played+=t-lastT;lastT=t;if(played>=GEN_AFTER)kickSong()});
    v.addEventListener('seeking',function(){lastT=null});
    document.addEventListener('preview:sales-visible',kickSong);
  }
}

/* ---- tiers, bump, total ---- */
var tiers=root.querySelectorAll('.bps-tier'),bump=$('bps-bump');
tiers.forEach(function(t){t.addEventListener('click',function(e){e.preventDefault();tiers.forEach(function(x){x.classList.remove('selected')});t.classList.add('selected');t.querySelector('input').checked=true})});
bump.addEventListener('click',function(e){e.preventDefault();bump.querySelector('input').checked=bump.classList.toggle('selected')});
cta.addEventListener('click',function(){
 /* Shopify cart permalink: /cart/VARIANT:1[,LYRICS:1]?note=…&attributes[…]=… (quiz answers travel with the order) */
 var VAR={rush:'49926013059310',standard:'49926013092078'},LYRICS='49926013550830';
 var t=root.querySelector('.bps-tier.selected'),tier=t.getAttribute('data-tier'),lyr=bump.classList.contains('selected');
 var items=[(t.getAttribute('data-variant-id')||VAR[tier]||VAR.rush)+':1'];
 if(lyr)items.push((bump.getAttribute('data-variant-id')||LYRICS)+':1');
 var cut=function(v,n){v=String(v||'').replace(/\s+/g,' ').trim();return v.length>n?v.slice(0,n-1)+'…':v};
 var enc=encodeURIComponent,story=[S.qualities,S.moments,S.message].filter(Boolean).join(' / ');
 function url(n){
  var song=[S.name,S.recipient&&'('+S.recipient+')'].filter(Boolean).join(' ');
  var note=[['Song for',song],['Occasion',S.occasion],['Genre',S.genre],['Voice',S.voice],['Language',S.language],['Story',cut(story,n)]]
   .filter(function(r){return r[1]}).map(function(r){return r[0]+': '+r[1]}).join('\n');
  var attrs=[['Recipient',S.name],['Relationship',S.recipient],['Occasion',S.occasion],['Genre',S.genre],['Voice',S.voice],['Language',S.language],
   ['Qualities',cut(S.qualities,n)],['Memories',cut(S.moments,n)],['Message',cut(S.message,n)],['Phone',S.phone],
   ['Delivery',tier==='standard'?'48-Hour Delivery':'30-Minute Delivery'],['Printed Lyrics',lyr?'Yes':'No'],['Quiz ID',S.quizId],
   ['Song Task ID',S.songTaskId],['Song Track ID',S.songTrackId],['Song Audio URL',S.songAudioUrl]];
  var q=['note='+enc(note)].concat(attrs.filter(function(a){return a[1]}).map(function(a){return 'attributes['+enc(a[0])+']='+enc(a[1])}));
  if(S.email)q.push('checkout[email]='+enc(S.email));
  return '/cart/'+items.join(',')+'?'+q.join('&');
 }
 /* keep the request line well under server limits: shorten the free-text answers until it fits */
 var n=600,u=url(n);while(u.length>6000&&n>40){n=Math.floor(n*0.7);u=url(n)}
 location.href=u});

/* ---- sticky CTA ---- */
var sb=$('bps-stickyCtaButton'),pi=$('bps-pricingIntro'),sc=$('bps-stickyCta');
sb.addEventListener('click',function(){pi.scrollIntoView({behavior:'smooth',block:'start'})});
function sc_(){var r=cta.getBoundingClientRect();sc.classList.toggle('visible',r.height>0&&r.bottom<=0)}
addEventListener('scroll',sc_,{passive:true});sc_();

/* ---- FAQ ---- */
root.querySelectorAll('.bps-faq-item').forEach(function(i){i.querySelector('.bps-faq-q').addEventListener('click',function(){i.classList.toggle('open')})});

/* ---- 29:59 countdown: starts when the sales block is revealed ---- */
/* declared via function hoisting: may run (skipPreview / #ready) before this point, so look the element up lazily */
var cdStarted;
function startCountdown(){if(cdStarted)return;cdStarted=true;var ex=$('bps-expiryTimer'),tot=1799;if(!ex)return;ex.textContent=f(tot);setInterval(function(){tot=Math.max(0,tot-1);ex.textContent=f(tot)},1000)}
})();
